export default __webpack_public_path__ + "static/mongodb-1bbf954aafb185719b5c322056953d12.svg";